import {
  getGroupData,
  getSelectedPeriod,
} from "../../../../services/GroupContext";
import { getNonConsentingStatus } from "../utils/fullReturnOutputUtils";
import {
  getCompanyNtiei,
  getCompanyTaxEbitda,
  getRelevantGroupCompanies,
} from "../utils/helpers";

const getAPData = (poaData, companyID) => {
  const companyAP = poaData.adjusted_caps.filter(
    (ap) => ap.company_ID === companyID,
  );
  return companyAP;
};

const doesQICExists = (poaData, companyID) => {
  let companyAPData = getAPData(poaData, companyID);

  const QICExists = companyAPData
    .map((ap) => ap.election_s433_s434)
    .some((value) => value === true);

  return QICExists ? "Y" : "N";
};

export const getUKGroupCompaniesExcelData = (excelData) => {
  const savedData = getGroupData();
  const poaData = getSelectedPeriod();
  const companies = getRelevantGroupCompanies();

  const ukGroupCompaniesList = [
    [],
    ["", "Interest Restriction Return Page 3"],
    [],
    [
      "",
      "Identifies UK group companies and shows net tax-interest and tax-EBITDA amounts",
    ],
    [],
    ["", "Fields below copy from p1"],
    excelData.ukGC_Row7,
    excelData.ukGC_Row8,
    excelData.ukGC_Row9,
    excelData.ukGC_Row10,
    [],
    ["", "", "Full return", "", "", "", "", "Full return only"],
    ["", "", "", "", "", "", "", "Forms part of statement of calculations"],
    [
      "",
      "Index no.",
      "UK Group companies - names",
      "UTR",
      "Enter NC if non-consenting",
      "QIC election?",
      "",
      "Net tax-interest expense",
      "Net tax-interest income",
      "Tax-EBITDA",
    ],
    [
      "",
      "",
      "These will copy through to sheets 5 and 6",
      "10 digits",
      "C/NC",
      "Y/N",
      "",
      "Zero, if net income",
      "Zero, if net expense",
      "Can be negative",
    ],
  ];

  const numOfCompanies = companies.length;
  const nonConsentingCompMap = getNonConsentingStatus(poaData, companies);
  for (let i = 0; i < 300; i++) {
    let rowNumber = i + 1;
    let row = ["", rowNumber, "", "", "", "", "", "", "", ""];

    if (i < numOfCompanies) {
      let companyName = companies[i].company_name;
      let companyUTR = companies[i].utr;
      let companyNC = nonConsentingCompMap.get(companies[i].company_ID) ? "NC" : "C";
      let companyQIC = doesQICExists(poaData, companies[i].company_ID);

      let ntiei = getCompanyNtiei(companies[i].company_ID);
      let ntie = ntiei < 0 ? 0 : ntiei;
      let ntii = ntiei > 0 ? 0 : -ntiei;
      let taxEbitda = getCompanyTaxEbitda(companies[i].company_ID);

      row = [
        "",
        rowNumber,
        companyName,
        companyUTR,
        companyNC,
        companyQIC,
        "",
        ntie,
        ntii,
        taxEbitda,
      ];
    }

    ukGroupCompaniesList.push(row);
  }

  const ukGroupCompaniesFooter = [
    [],
    ["", "", "", "", "", "", "", "Group totals (full return only)"],
    [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Sub-total (optional)",
      "Sub-total (optional)",
    ],
    ["", "", "", "", "", "", ""],
    ["", "", "Key", "", "", "", ""],
    [
      "",
      "",
      "Descriptive field or date",
      "Numerical entry, £",
      "Note",
      "",
      "",
      "Aggregate net tax-interest expense",
      "Aggregate net tax-interest income",
      "Aggregate tax-EBITDA (not negative)",
    ],
    ["", "", "", "", "", "", ""],
  ];

  const rows = ukGroupCompaniesList.concat(ukGroupCompaniesFooter);

  return rows;
};
